(function () {

  if (!document.body.classList.contains('template-collection-frontpage')) {
    return;
  }

  function addTrackingClass() {

    document.querySelectorAll('.restock-rocket-collection-rendered')
      .forEach(function(el) {

        if (!el.classList.contains('shop-lapstacker-click')) {
          el.classList.add('shop-lapstacker-click');
        }

      });

  }
  addTrackingClass();
  const observer = new MutationObserver(function() {
    addTrackingClass();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();


(function () {

  window.dataLayer = window.dataLayer || [];

  var requiredMs = 10000;
  var STORAGE_KEY = 'site_engagement_time';
  var FIRED_KEY = 'site_engagement_fired';

  var visibleAccum = parseInt(
    sessionStorage.getItem(STORAGE_KEY) || '0',
    10
  );

  var fired = sessionStorage.getItem(FIRED_KEY) === 'true';

  var lastStart = null;
  var tick = null;

  window.timeSpent60 = fired;

  function now() {
    return Date.now();
  }

  function saveTime() {
    sessionStorage.setItem(STORAGE_KEY, visibleAccum);
  }

  function fireEvent(value, currency) {

    if (fired) return;
    fired = true;
    window.timeSpent60 = true;
    sessionStorage.setItem(FIRED_KEY, 'true');

    window.dataLayer.push({
      event: 'time_spent',
      engagedSeconds: 30,
      value: value || 1,
      currency: currency || 'AUD',
      pagePath: location.pathname,
      pageTitle: document.title
    });

  }

  function startTicking() {

    if (fired || tick || document.hidden) return;
    lastStart = now();
    tick = setInterval(function () {
      if (document.hidden) {
        stopTicking();
        return;
      }

      var current = now();
      visibleAccum += (current - lastStart);
      lastStart = current;
      saveTime();
      if (visibleAccum >= requiredMs) {
        stopTicking();
        fireEvent();
      }
    }, 3000);

  }

  function stopTicking() {
    if (tick) {
      clearInterval(tick);
      tick = null;
    }

  }

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      stopTicking();

    } else {
      lastStart = now();
      startTicking();
    }

  });

  if (!document.hidden) {
    startTicking();
  }

  window.addEventListener('load', function () {
    if (!document.hidden) {
      startTicking();
    }
  });

  document.addEventListener('click', function (e) {
    var el = e.target.closest('#shop-lapstacker, .shop-lapstacker-click');
    if (!el) return;
    var productCard =
      el.closest('.product-card') ||
      el.closest('.card') ||
      el.closest('.grid-product') ||
      el.closest('.product-item') ||
      document;

    var priceEl = productCard.querySelector('sale-price span');
    var rawPrice = priceEl
      ? priceEl.textContent.trim()
      : '';
    var cleanPrice = rawPrice
      .replace(/[^0-9.,]/g, '')
      .replace(/,/g, '');

    var value = parseFloat(cleanPrice) || 1;
    var currency =
      window.Shopify?.currency?.active || 'AUD';

    window.dataLayer.push({
      event: 'shop_lapstacker',
      value: value,
      currency: currency,
      pagePath: location.pathname,
      pageTitle: document.title
    });

    if (window.timeSpent60) {

      window.dataLayer.push({
        event: 'engaged_shopper',
        engagedSeconds: 30,
        value: value,
        currency: currency,
        pagePath: location.pathname,
        pageTitle: document.title
      });

    }

  });

})();
